import { all, takeLatest, takeEvery } from 'redux-saga/effects';
import combineSaga from './modules';

export const dispatchActionType = (type, payload) => {
  return {
    type,
    payload,
  };
};

const generatedWatchedServices = Object.entries(combineSaga).map(([typeAction, act]) => {
  if (act.takeEvery) {
    return takeEvery(typeAction, act.saga);
  }
  return takeLatest(typeAction, act.saga);
});

export function* watchCreatorSaga() {
  yield all(generatedWatchedServices.map((saga) => saga));
}
